import { render, staticRenderFns } from "./UserListPanel.vue?vue&type=template&id=c2252c12&scoped=true"
import script from "./UserListPanel.vue?vue&type=script&lang=ts"
export * from "./UserListPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2252c12",
  null
  
)

export default component.exports